import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { RatePlan } from "./rate-plan.model";

/**
 * @class RatePlanInterval
 * @property {number} id
 * @property {RatePlan} ratePlan
 * @property {string} name
 */
export class RatePlanInterval extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    /**
     * @param {Object|RatePlan} value
     * @returns {RatePlan}
     */
    setRatePlan(value) {
        
        return value instanceof RatePlan ? value : new RatePlan(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'INTERVAL_NAME_IN_ENGLISH',
                commonLabel: 'Interval name'
            },
            name_ar: {
                label: 'INTERVAL_NAME_IN_ARABIC',
                commonLabel: 'Interval name'
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...RatePlanInterval.translatableAttributesWithLanguageAliases, 'rate_plan_id', 'rate_plan', 'start_date', 'end_date',
        'min_los', 'max_los', 'cut_off', 'last_minute_booking', 'closed_to_arrival', 'closed_to_departure', 'property_accommodation_types', 'created_at',
        'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat')(RatePlanInterval);


// WEBPACK FOOTER //
// ./src/pms-api/models/rate-plan-interval.model.js